<template lang="pug">
  v-app#app
    ModalNotif(:openModalNotif="openModalNotif" @closeModal="openModalNotif = false" :message="messageModalNotif")
    NavDrawer(v-if="showToolbarAndNavDrawer && $route.name !== 'Approval Landing Page'" ref="drawer")
    Toolbar(title="i-Permit" v-if="showToolbarAndNavDrawer && $route.name !== 'Approval Landing Page'")
    AlertPjsModal(v-if="setAlertPjsModal")
    router-view
    Footer(v-if="$route.name !== 'Login' && $route.name !== 'Logout' && $route.name !== 'Approval Landing Page'")
    Loader
    Snackbar
</template>

<script>
import axios from "axios";
import NavDrawer from "./components/NavDrawer.vue";
import Toolbar from "./components/Toolbar.vue";
import Footer from "./components/Footer.vue";
import Loader from "./components/partials/_loader.vue";
import ModalNotif from "./components/ModalNotif.vue";
import Snackbar from "./components/partials/Snackbar.vue";
import { mapState } from "vuex";
import AlertPjsModal from "@/components/modal/AlertPjsModal.vue";
import moment from "moment-timezone";

export default {
  name: 'App',
  components: {
    NavDrawer,
    Toolbar,
    Footer,
    ModalNotif,
    Loader,
    Snackbar,
    AlertPjsModal
  },
  data() {
    return {
      openModalNotif: false,
      setAlertPjsModal: false,
      messageModalNotif: ''
    }
  },
  computed: {
    ...mapState(["openModalNot", "modalNeedSetPjs"]),
    showToolbarAndNavDrawer() {
      // if (this.$route.path.match(/^\/page-approval/g)) return false;
      if (!this.$store.getters.isAuthenticated) return false;
      return true;
    },
  },
  updated() {
    this.setAlertPjsModal = this.modalNeedSetPjs;
  },
  created() {
    // Add a request interceptor
    let self = this
    axios.interceptors.request.use(function (config) {
      self.loading(true)
      config.headers['Client-Timezone'] = moment.tz.guess();
      return config;
    }, (error) => {
      self.loading(false)
      return Promise.reject(error);
    });

    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
      self.loading(false)
      return response;
    }, (error) => {
      self.loading(false)
      if (!('response' in error)) return Promise.reject(error);
      if (error?.response?.status === 401 && error?.response?.data?.message === 'Profil updated') {
        // this.openModalNotif = true;
        // this.messageModalNotif = 'Ada Pembaharuan sistem iPermit, silahkan relogin!';

        this.$store.dispatch('logout');
        this.$router.push('/login');
      }
      return Promise.reject(error);
    });
  },
  methods: {
    loading(payload) {
      this.$store.commit('loader', payload)
    }
  },
  watch: {
    $route(params) {
      const urlPath = [
        "/user-list", "/List-permit", "/"
        , "/add-user", "/edit-user", "/admin"
        , "/my-permit", "/my-approval-list"
        , "/add-izin-ruang-terbatas", "/add-izin-penggalian"
        , "/add-izin-ketinggian", "/add-izin-kerja-dengan-panas"
        , "/add-izin-peledakan", "/add-izin-jangka-pendek"
      ]

      if (urlPath.includes(params.path)) {
        if (this.openModalNot !== localStorage.getItem('appVersion')) {
          this.openModalNotif = true
        }
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Arial, Verdana, Tahoma, sans-serif;
}

.confirm-action-default {
  text-transform: none;
  width: 170px;
  height: 38px;
  font-size: 14px;
  font-weight: 600;
  color: #5C5A5A !important;
  background-color: #E0E0E0 !important;
}

.confirm-action-danger {
  text-transform: none;
  width: 170px;
  height: 38px;
  font-size: 14px;
  font-weight: 600;
  color: #FFFFFF !important;
  background-color: #ED1B24 !important;
}

.confirm-action-success {
  text-transform: none;
  width: 170px;
  height: 38px;
  font-size: 14px;
  font-weight: 600;
  color: #FFFFFF !important;
  background-color: #1FC1A2 !important;
}

.confirm-body div {
  color: #70829A !important;
}
</style>
